<template>
  <el-dialog title="Edit Linked Transaction" :close-on-click-modal="false" :visible.sync="visible" width="1460px" top="3vh">
    <div class="pb20">
      <el-button type="primary" plain @click="addLinkedTransaction">Add</el-button>
    </div>
    <div class="tableBorder">
      <el-form :model="dataForm" ref="dataForm" autocomplete="off" label-position="top">
        <el-row :gutter="10" class="customTh">
          <el-col :span="3" class="tac">
            <span class="red">*</span>
            Transaction No.
            <el-popover placement="bottom" trigger="hover">
              <span class="fs12">Data Source: "Operation" section of this system</span>
              <span slot="reference" class="pearl-blue fs16 ml4 el-icon-warning"></span>
            </el-popover>
          </el-col>
          <el-col :span="5" class="tac">Supplier</el-col>
          <el-col :span="2" class="tac">Currency</el-col>
          <el-col :span="4" class="tac">Related Transaction</el-col>
          <el-col :span="4" class="tac">Related Turnover</el-col>
          <el-col :span="5" class="tac">
            <span class="red">*</span>
            In-charge
            <el-popover placement="bottom" trigger="hover">
              <span class="fs12">Data Source: "Settings-User" section of this system</span>
              <span slot="reference" class="pearl-blue fs16 ml4 el-icon-warning"></span>
            </el-popover>
          </el-col>
          <el-col :span="1" class="tac">Action</el-col>
        </el-row>

        <div class="customTbody" v-for="(parent, index) in dataForm.dataList" :key="`dataList-${index}`">
          <el-row :gutter="10" class="fxRow">
            <el-col :span="3">
              <el-form-item
                :prop="`dataList.${index}.transactionNo`"
                :ref="`dataList.${index}.transactionNo`"
                :rules="{
                  required: true,
                  message: 'please select',
                  trigger: 'submit',
                }"
              >
                <el-select
                  v-model="parent.transactionNo"
                  placeholder="Transaction No."
                  clearable
                  filterable
                  remote
                  :remote-method="getTransactionNoRemote"
                  @clear="getTransactionNoRemote('')"
                  @focus="getTransactionNoRemote('')"
                  :loading="transactionNoLoading"
                  :disabled="isHasTransactionNo(parent.transactionNo)"
                  :title="isHasTransactionNo(parent.transactionNo) ? 'Have been used' : ''"
                  @change="
                    val => {
                      transactionNoChange(val, parent);
                    }
                  "
                  class="wdb100"
                >
                  <el-option
                    v-for="(item, xv) in transactionNoList"
                    :key="`transactionNo-${item.transactionNo}-${xv}`"
                    :label="item.transactionNo"
                    :value="item.transactionNo"
                    :disabled="isHasSelectedList(item.transactionNo)"
                    style="height: auto; padding: 8px 20px"
                  >
                    <div>
                      <div class="lh20">{{ item.transactionNo }}</div>
                      <div class="flex">
                        <div v-for="(ele, idx) in item.companyInfoList" :key="`option-${xv}-${idx}`" class="lh14 fs12 grey mr4">
                          {{ idx > 0 ? "/" : "" }} {{ ele.uen }} - {{ ele.companyName }}
                        </div>
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" class="tac">
              <el-form-item>
                <p class="lh18 enbr m0">{{ parent.supplierName }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item :prop="`dataList.${index}.currency`" :ref="`dataList.${index}.currency`">
                <el-select v-model="parent.currency" placeholder="Currency" clearable filterable>
                  <el-option
                    v-for="(item, idx) in currencyList"
                    :key="`currency-${index}-${idx}`"
                    :label="item.currency"
                    :value="item.currency"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`dataList.${index}.relatedTransaction`" :ref="`dataList.${index}.relatedTransaction`">
                <el-input v-model="parent.relatedTransaction" v-minusPoint2 clearable placeholder="0.00" class="wdb100">
                  <template slot="prefix">{{ currencySymbolFormat(parent.currency) }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`dataList.${index}.relatedTurnover`" :ref="`dataList.${index}.relatedTurnover`">
                <el-input v-model="parent.relatedTurnover" v-minusPoint2 clearable placeholder="0.00" class="wdb100">
                  <template slot="prefix">{{ currencySymbolFormat(parent.currency) }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :prop="`dataList.${index}.inChargeUserIds`"
                :ref="`dataList.${index}.inChargeUserIds`"
                :rules="{
                  type: 'array',
                  required: true,
                  message: 'please select',
                  trigger: 'submit',
                }"
              >
                <el-select v-model="parent.inChargeUserIds" clearable filterable multiple placeholder="In-charge" class="wdb100">
                  <el-option
                    v-for="(item, idx) in inChargeList"
                    :key="`inCharge-${index}-${idx}`"
                    :label="`${item.nickname}-${item.staffNo}-${item.position}`"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="1" class="tac">
              <el-form-item>
                <span class="fs14 crp red" @click="dataForm.dataList.splice(index, 1)" v-if="!isHasTransactionNo(parent.transactionNo)">Delete</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    engagementId: {
      type: String,
      require: true,
    },
    inChargeList: {
      type: Array,
      default: () => [],
    },
    controlDataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        dataList: [],
      },
      transactionNoLoading: false,
      transactionNoList: [],
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
    // 判断Engagement Control列表中是否存在transaction No；如果存在，就不能修改或删除
    isHasTransactionNo() {
      return transactionNo => {
        if (transactionNo) {
          let transactionNoList = [];
          this.controlDataList.forEach(element => {
            if (element.linkedTransactionNo != null && element.linkedTransactionNo.length > 0) {
              transactionNoList.push(...element.linkedTransactionNo);
            }
          });
          return transactionNoList.includes(transactionNo);
        } else {
          return false;
        }
      };
    },
    // 判断选项(option)是否已经被选中
    isHasSelectedList() {
      return transactionNo => {
        if (transactionNo) {
          const newArr = this.dataForm.dataList.map(item => item.transactionNo);
          return newArr.includes(transactionNo);
        } else {
          return false;
        }
      };
    },
  },
  methods: {
    // 获取Transaction No列表
    getTransactionNoRemote(query) {
      this.transactionNoLoading = true;
      this.$http
        .get("/admin/businessInfo/getListWithAmount", {
          params: {
            keywords: query,
          },
        })
        .then(res => {
          const resData = res.data || [];
          this.transactionNoList = resData;
        })
        .catch(err => {
          this.transactionNoList = [];
        })
        .finally(() => {
          this.transactionNoLoading = false;
        });
    },
    // 初始化
    async init(list) {
      this.submitLoading = false;
      this.visible = true;
      // 需要手动设置为[],不然会报错
      this.$set(this.dataForm, "dataList", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      this.getTransactionNoRemote("");
      const listCopy = list.map(item => {
        return {
          transactionNo: item.transactionNo,
          businessType: item.businessType,
          businessId: item.businessId,
          supplierId: item.supplier?.id || null,
          supplierName: item.supplier?.companyName || "",
          currency: item.currency,
          inChargeUserIds: item?.inChargeUsers.map(ele => ele.id) || [],
          relatedTransaction: item.relatedTransaction,
          relatedTurnover: item.relatedTurnover,
        };
      });
      this.dataForm = {
        dataList: listCopy,
      };
    },
    // add
    addLinkedTransaction() {
      this.dataForm.dataList.push({
        transactionNo: "",
        businessType: "",
        businessId: null,
        supplierId: null,
        supplierName: "",
        currency: null,
        relatedTransaction: null,
        relatedTurnover: null,
        inChargeUserIds: [],
      });
      this.$forceUpdate();
    },
    // Transaction No. - change
    transactionNoChange(transactionNo, parent) {
      const resItem = this.transactionNoList.find(item => item.transactionNo == transactionNo);
      parent.businessType = resItem?.businessType;
      parent.businessId = resItem?.businessId;
      parent.currency = resItem?.currency;
      parent.supplierId = resItem?.supplier?.id || null;
      parent.supplierName = resItem?.supplier?.companyName || "";
      parent.relatedTransaction = resItem?.relatedTransactionAmount;
      parent.relatedTurnover = resItem?.relatedTurnoverAmount;
      this.$forceUpdate();
    },
    // 保存
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          // 判断数组中是否存在重复的transactionNo
          const newArr = this.dataForm.dataList.map(item => item.transactionNo);
          const isRepeat = newArr.some((x, index, arr) => arr.findIndex(y => y == x) != index);
          if (isRepeat) {
            this.$message.warning("Duplicate Transaction No. Exist");
            return;
          }
          this.submitLoading = true;
          this.$http
            .post("/admin/engagementAndTransactionManage/saveRelatedTransactions", {
              engagementId: this.engagementId,
              dataList: this.dataForm.dataList,
            })
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.$emit("linkedTransactionsFeedback");
                  this.visible = false;
                },
              });
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";
.blue {
  color: $--color-primary;
}

.red {
  color: $--color-danger;
}

.tableBorder {
  .customTh {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    background-color: #f4f8fe;
    border-bottom: 1px solid #ebeef5;
  }

  .customTbody {
    padding: 16px 0 0;
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
